import Colors from '@root/gatsby-contentful-core/src/utils/colors';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import StatesData from '@root/joinroot.com/src/assets/data/states';
import WashingtonDC from '@root/joinroot.com/src/components/sections/availability-map/washington-dc';
import { StyleSheet } from '@root/core/src/utils/styles';

const stateClassStatusMapping = {
  available: 'state-available',
  soon: 'state-coming-soon',
  unavailable: 'state-unavailable',
};

function buildPageLink(state) {
  if (!state.page) { return; }

  const name = state.name.toLowerCase().split(' ').join('-');

  return `/availability/${name}-car-insurance/`;
}

export default function AvailabilityMap({ onClick }) {
  return (
    <svg
      css={styles.availabilityMap}
      viewBox={'0 0 980 593'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <title>Map of United States</title>
      <g css={styles.states}>
        {StatesData.map((state, index) => {
          return (
            <a
              className={stateClassStatusMapping[state.status]}
              css={styles.stateLink}
              data-state-id={state.id}
              data-testid={state.id}
              href={buildPageLink(state)}
              key={index}
              onClick={(e) => onClick(e, state)}
              tabIndex={'-1'}
            >
              <path
                className={'state'}
                css={styles.state}
                d={state.shape.dimensions}
              />
              <title>{state.name}</title>
              {state.shape.labelLine &&
                <path
                  css={styles.labelLine}
                  d={state.shape.labelLine.dimensions}
                  transform={'translate(0, -0.4)'}
                />
              }
              {!state.shape.labelLine && state.status !== 'unavailable' &&
                <text
                  css={styles.stateLabel}
                  transform={`${state.shape.labelTransform}`}
                >
                  {state.id.toUpperCase()}
                </text>
              }
              {state.shape.labelLine && state.status !== 'unavailable' &&
                <text
                  css={[styles.stateLabel, styles.stateLabelWithLine]}
                  transform={`${state.shape.labelTransform}`}
                >
                  {state.id.toUpperCase()}
                </text>
              }
            </a>
          );
        })}

        <WashingtonDC
          onClick={onClick}
          styles={styles}
        />
      </g>
    </svg>
  );
}

const styles = StyleSheet.create({
  availabilityMap: {
    width: '100%',
    maxWidth: 940,
    height: 'auto',
  },
  stateLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  state: {
    fill: Colors.grayLight(),
    transition: 'fill 300ms ease-in-out',
    '.state-available &': {
      fill: Colors.rootOrange(),
    },
    '.state-available:hover &': {
      fill: '#c83800',
    },
    '.state-coming-soon &': {
      fill: Colors.rootOrangeLight(),
    },
    '.state-coming-soon:hover &': {
      fill: '#ce785e',
    },
    '.state-unavailable:hover &': {
      fill: '#f0cdc7',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  stateLabel: {
    fill: Colors.white(),
    fontSize: 24,
    '@media screen and (min-width: 768px)': {
      fontSize: 18,
    },
  },
  labelLine: {
    strokeWidth: 1,
    transition: 'stroke 300ms ease-in-out',
    '.state-available &': {
      stroke: Colors.rootOrange(),
    },
    '.state-available:hover &': {
      stroke: '#c83800',
    },
    '.state-coming-soon &': {
      stroke: Colors.rootOrangeLight(),
    },
    '.state-coming-soon:hover &': {
      stroke: '#ce785e',
    },
  },
  stateLabelWithLine: {
    transition: 'fill 300ms ease-in-out',
    '.state-available &': {
      fill: Colors.rootOrange(),
    },
    '.state-available:hover &': {
      fill: '#c83800',
    },
    '.state-coming-soon &': {
      fill: Colors.rootOrangeLight(),
    },
    '.state-coming-soon:hover &': {
      fill: '#ce785e',
    },
  },
});

AvailabilityMap.propTypes = {
  onClick: PropTypes.func.isRequired,
};
